namespace $.$$ {

	export class $shm_ba_chart_tags extends $.$shm_ba_chart_tags {

		option() {
			const rows = this.rows() as readonly ( readonly [ string, number ] )[]
			return {
				tooltip: { trigger: 'item' },
				legend: { orient: 'vertical', left: 0, top: 24 },
				series: [{
					name: 'Сообщений по тегам',
					type: 'pie',
					radius: [ '35%', '70%' ],
					center: [ '58%', '52%' ],
					data: rows.map( ([ name, value ])=> ({ name, value }) ),
				}],
			}
		}

	}

}
